/**
 * Which build this is: version, build time, and the commit it came from. All
 * three are substituted at build time by `define` in `vite.config.ts`.
 *
 * It exists to be read off a phone screenshot over WhatsApp in November by
 * someone who is not looking for it, so it is quiet but not decorative — see
 * `.site-foot-build`, which deliberately dims with colour rather than with a
 * second `opacity` on top of the footer's own.
 *
 * **A component rather than a line in the footer, because the footer does not
 * reach the screens most likely to be broken.** `SiteFoot` renders inside
 * `Shell`, and the sign-in screens are routed outside it — so a guest who
 * cannot get past sign-in, which is the failure this whole week is most
 * exposed to (D46), was on the one screen that could not tell you what it was
 * running.
 *
 * `/display` is deliberately still without one: nobody wants a commit hash on
 * the wall behind the couple.
 */
export const BUILD = `v${__APP_VERSION__} · ${__BUILD_TIME__} · ${__APP_COMMIT__}`;

export default function BuildStamp() {
  return <span className="site-foot-build">{BUILD}</span>;
}
